import type * as React from "react"

import { AgentStateBadge } from "@/components/agents/agent-state-badge"

import RecordPageHeaderMenu from "./record-page-header-menu"

export interface RecordPageHeaderAction {
  label: string
  onClick?: () => void
  href?: string
  // Render as a button next to Edit instead of inside the ... dropdown.
  inline?: boolean
}

interface RecordPageHeaderProps {
  title: string
  state?: string
  editPath?: string
  deletePath?: string
  // When set, the Delete option renders disabled with this text as its tooltip.
  deleteDisabledReason?: string
  actions?: RecordPageHeaderAction[]
  // Extra badges rendered alongside the state badge (e.g. "Demo account").
  badges?: React.ReactNode
}

export default function RecordPageHeader({
  title,
  state,
  editPath,
  deletePath,
  deleteDisabledReason,
  actions,
  badges,
}: RecordPageHeaderProps) {
  const hasMenu =
    Boolean(editPath) || Boolean(deletePath) || Boolean(actions?.length)

  return (
    <div className="flex items-center justify-between pt-8">
      <h1 className="flex items-center gap-4 text-2xl/8 font-semibold">
        <span>{title}</span>
        {(state ?? badges) && (
          <span className="flex items-center gap-2">
            {state && <AgentStateBadge state={state} />}
            {badges}
          </span>
        )}
      </h1>
      {hasMenu && (
        <RecordPageHeaderMenu
          editPath={editPath}
          deletePath={deletePath}
          deleteDisabledReason={deleteDisabledReason}
          actions={actions}
        />
      )}
    </div>
  )
}
